import { render } from "./DefaultLayout.vue?vue&type=template&id=790e6bd0&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=790e6bd0&lang=css"
import "./DefaultLayout.vue?vue&type=style&index=1&id=790e6bd0&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790e6bd0"]])

export default __exports__